module.exports = __webpack_public_path__ + "static/media/tokio.5860d233.png";